import React from 'react';

const GalleryModal = ({ show, onClose, getRootProps, getInputProps, isDragActive }) => {
  if (!show) return null;
  return (
    <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Select Image from Gallery</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-center">
            <div {...getRootProps()} style={{ border: '2px dashed #90caf9', borderRadius: 12, padding: 30, cursor: 'pointer', background: isDragActive ? '#e3f2fd' : '#f8fbff' }}>
              <input {...getInputProps()} />
              {isDragActive ? <p>Drop the image here ...</p> : <p>Drag & drop an image here, or click to select</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryModal;
